import { useIntl } from 'react-intl'
import { CurrencyInput } from 'ui'
import { ShippingVariantSelector } from '../../../../../../ShippingVariantSelector'
import { SettingsProps } from '../../../hooks/useGenericComponent'
import { messages } from './messages'

export function MaxShippingEditor(props: SettingsProps) {
  const { state } = props
  const { $t } = useIntl()

  return (
    <>
      <CurrencyInput
        name="value"
        state={state}
        aria-label={$t(messages.editor.ariaLabel)}
        helpText={$t(messages.editor.helpText)}
      />
      <ShippingVariantSelector state={state} />
    </>
  )
}
